import {filter, map} from 'rxjs/operators';
import {popupUtil} from '@/helper/popup';
import {userInfo$} from '@/store/user';
import WithMainAccount from './WithMainAccount.svelte';

export const isSubAccount$ = userInfo$.pipe(
  filter((userInfo) => !!userInfo.userId),
  map((userInfo) => !userInfo.isMain)
);

export function openSubAccountWarning(LG) {
  popupUtil.create(WithMainAccount, {LG, autoNavigation: false});
}
